/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'upload-outline': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M9 10v6h6v-6h4l-7-7-7 7h4m3-4.2L14.2 8H13v6h-2V8H9.8L12 5.8M19 18H5v2h14v-2z"/>'
  }
})
